var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.notasFiscais),function(notaFiscal){return _c('px-nota-fiscal-item',{key:notaFiscal.id,attrs:{"nota-fiscal":notaFiscal}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }